import { useDirtyContext } from '@data-loss/providers';
import { FC, useEffect } from 'react';

export type DirtyFormProps = {
  dirty: boolean;
};

/**
 * Represents a functional component that manages the "dirty" state of a form.
 *
 * This component integrates with an unload context to signal whether the form has unsaved changes.
 * It updates the "dirty" state in the context whenever the associated prop changes.
 */
export const DirtyForm: FC<DirtyFormProps> = ({ dirty }) => {
  const context = useDirtyContext();

  useEffect(() => {
    context.setDirty(dirty);

    return () => {
      context.setDirty(false);
    };
  }, [dirty]);

  return null;
};
